module.exports = __webpack_public_path__ + "static/img/14010114.9c9775b2.png";